// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"1692348f","769":"bda0d7b7"}[chunkId] + ".chunk.js";
};